import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppStateService} from './app.state.service';
import {Router} from '@angular/router';
import {ErrorHelper} from '../_handlers/error.handler';
import {Authentication} from '../_modals/auth.response';
import {catchError, map} from 'rxjs/operators';


@Injectable()
export class AuthenticationService {

    private baseUrl = environment.baseUrl;

    constructor(private http: HttpClient,
                private appState: AppStateService,
                private router: Router,
                private nativeHttp: HttpClient,
                private errorHelper: ErrorHelper) {

        let auth = localStorage.getItem('auth');
        let remember = localStorage.getItem('remember');
        let isAuthPage = this.router.url.endsWith('auth');
        let dUser;
        if ((!isAuthPage && auth) || (auth && isAuthPage && remember === 'true')) {
            dUser = JSON.parse(auth) as Authentication;
            this.appState
                .set('auth', dUser);
        } else {
            localStorage.clear();
        }

    }

    private getAuthObjectFromLocalStorage() {
        let auth = localStorage.getItem('auth');
        let dUser;
        if (auth) {
            dUser = JSON.parse(auth) as Authentication;
        }
        return dUser;
    }

    private getLoggedInAuthObject() {
        let auth: Authentication = this.appState.get('auth');
        if (!auth) {
            let dbAuth = this.getAuthObjectFromLocalStorage();
            if (!dbAuth) {
                this.router.navigate(['/auth']);
                /*return empty auth object to avoid NullPointerException*/
                auth = new Authentication();
                return auth;
            }
            auth = dbAuth;
        }
        return auth;
    }

    login(username, password) {
        const data = {'username': username, 'password': password};
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        let options = {headers: headers};

        return this.http.post<Authentication>(this.baseUrl + 'user/login/', data, options)
            .pipe(
                catchError(e => this.errorHelper.handleError(e)),
                map(r => this.errorHelper.mapToError(r)),
                map(tr => <Authentication>tr)
            );
    }


    saveAuthentication(auth: Authentication, remember) {
        if (auth.key) {
            localStorage.setItem('auth', JSON.stringify(auth));
            this.appState.set('auth', auth);
        }

        return auth;

    }

}
